import React from "react";
import EvaluatePropertyStatus from "./components/evaluatePropertyStatus";
import EvaluateNotifyOwner from "./components/evaluateNotifyOwner";
import MakeReadyEmail from "./components/makeReadyEmail";
import StingrayMakeReady from "./components/stingrayMakeReady";
import OwnerConcerns from "./components/ownerConcerns";
import UtilitiesLawn from "./components/utilitiesLawn";
import EndingProcess from "./components/endingProcess";
import SMakeReady from "./components/SMakeReady";
import MakeReadyFund from "./components/makeReadyFund";
import OwnerShortFund from "./components/ownerShortFund";
import OwnerDoingMakeReady from "./components/ownerDoingMakeReady";
import InspectionFee from "./components/inspectionFee";
import UtilityActivation from "./components/utilityActivation";
import LawnCareStart from "./components/LawnCareStart";
import WorkCompleted from "./components/workCompleted";
import EndingManagment from "./components/endingManagment";
import CancelMakeReady from "./components/cancelMakeReady";
import FAQLinks from "./components/FAQLinks";

const MakeReadyContent = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <EvaluateNotifyOwner
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <EvaluatePropertyStatus
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <MakeReadyEmail
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <StingrayMakeReady
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <SMakeReady
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <OwnerConcerns
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <MakeReadyFund
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <OwnerShortFund
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <OwnerDoingMakeReady
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <InspectionFee
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 11 && (
        <UtilitiesLawn
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <UtilityActivation
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 13 && (
        <LawnCareStart
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 14 && (
        <WorkCompleted
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 15 && (
        <EndingProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 16 && (
        <EndingManagment
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 17 && (
        <CancelMakeReady
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 18 && (
        <FAQLinks itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
    </div>
  );
};

export default MakeReadyContent;
